import { AuthConfig } from 'angular-oauth2-oidc';
import { SIGNED_OUT_ROUTE } from '@ascent/shared';

import { environment } from '../environments/environment';

/**
 * private interface for appSettings
 */
interface AppSettings {
  version: string;
  release: string;
  stage: string;
  isProduction: boolean;
  endpoints: {
    structure: {
      apiRoutes: string;
      products: string;
      productPolicies: string;
      services: string;
      serviceProjects: string;
      serviceProjectNamespaces: string;
      serviceProjectNamespaceModels: string;
      usecases: string;
    },
    modeling: {
      dataModels: string;
      domainModels: string;
      domains: string;
      dtos: string;
      entities: string;
      enumerations: string;
      features: string;
      models: string;
    }
  };
  authentication: {
    oidc: AuthConfig;
  };
}

export const appSettings: AppSettings = {
  version: '1.0.0',
  release: 'Release 30.09.2026',
  stage: environment.stage,
  isProduction: environment.production,
  authentication: {
    oidc: {
      issuer: environment.oidc.authority + '/',
      redirectUri: environment.baseUrls.uiUrl,
      // The signed-out page, not the application root. Returning to the root would start a new
      // sign-in and the sign-out would last one redirect. **This address has to be registered in
      // Cardinal as a post logout redirect uri**, or the logout ends on Cardinal's own page.
      postLogoutRedirectUri: environment.baseUrls.uiUrl + SIGNED_OUT_ROUTE,
      clientId: environment.oidc.clientId,
      scope: environment.oidc.scope,
      // Authorization code flow with PKCE. The library switches PKCE on by itself once the response
      // type contains 'code' and produces S256; there is nothing to configure and no flag to set.
      //
      // Gone with the flow: silentRefreshRedirectUri, which has no purpose without the iframe, and
      // clearHashAfterLogin, which only ever applied to a fragment response -- the code comes back in
      // the query string and the library clears it with history.replaceState.
      responseType: 'code',
      customTokenParameters: ['app_metadata', 'user_metadata', 'AccountId', 'email', 'name', 'sub', 'TenantId', 'PreferredLanguage', 'UserAccountGuid', 'AccountName'],
      requireHttps: environment.oidc.requireHttps
    }
  },
  endpoints: {
    structure: {
      apiRoutes: environment.baseUrls.ascentUrl + '/apiroutes',
      products: environment.baseUrls.ascentUrl + '/products',
      productPolicies: environment.baseUrls.ascentUrl + '/products/:productId/policies',
      services: environment.baseUrls.ascentUrl + '/services',
      serviceProjects: environment.baseUrls.ascentUrl + '/services/:serviceId/projects/:type',
      serviceProjectNamespaces: environment.baseUrls.ascentUrl + '/services/:serviceId/projects/:type/:projectId/namespaces',
      serviceProjectNamespaceModels: environment.baseUrls.ascentUrl + '/services/:serviceId/projects/:type/:projectId/namespaces/:namespaceId/models',
      usecases: environment.baseUrls.ascentUrl + '/usecases',
    },
    modeling: {
      domains: environment.baseUrls.ascentUrl + '/domains',
      entities: environment.baseUrls.ascentUrl + '/entities',
      enumerations: environment.baseUrls.ascentUrl + '/enumerations',
      features: environment.baseUrls.ascentUrl + '/features',
      dataModels: environment.baseUrls.ascentUrl + '/models/data',
      domainModels: environment.baseUrls.ascentUrl + '/models/domain',
      dtos: environment.baseUrls.ascentUrl + '/models/dto',
      models: environment.baseUrls.ascentUrl + '/models'
    }
  }
};
